import { IAnnualReport, IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { IOptions, ISectionData, PDFSectionIds } from '../../../../../../../../aumico-lib-annualreport-fe/src/lib';
import { ArFeatureBasePDFSectionBaseFactory } from '../../../../../_base/arFeatureBasePdfSectionBase.factory';
import { FcpModel } from '../../domain/models/fcp.model';

export class FcpPDFSectionFactory extends ArFeatureBasePDFSectionBaseFactory<FcpModel> {
    createSectionWithDefaultOptions(domainModel: FcpModel): ISectionData {
        const pdfTronData: ISectionData = {
            sectionId: PDFSectionIds.FCP,
            title: this.i18nextService.t('aumico_annual_report_print_preview_fcp') as string,
            hasSignature: false,
            data: 'FCP',
        };
        console.log('createSectionWithDefaultOptions');
        // Additional mixin methods can be added here
        return pdfTronData;
    }
    createSection(
        annualReport: IAnnualReport,
        printOptions: IPrintOptions,
        annualReportForAutofill: IAnnualReport,
        reportOrder: string[],
        options: IOptions,
        predifinedLables: Map<string, string>,
        formatLocale: string,
        translationLocale: string,
        reportLocale: string,
    ): ISectionData {
        const pdfTronData: ISectionData = {
            sectionId: PDFSectionIds.FCP,
            title: this.i18nextService.t('aumico_annual_report_print_preview_fcp') as string,
            hasSignature: false,
            data: annualReport.generalInformation.company.name,
        };
        // Additional mixin methods can be added here
        return pdfTronData;
    }
}
